if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this._restoreCheckbox();
    }

    _restoreCheckbox() {
      const checkbox = document.getElementById('upsell-addon-checkbox');
      if (!checkbox) return;
      if (sessionStorage.getItem('caddy-checked') === 'true') {
        checkbox.checked = true;
      }
      checkbox.addEventListener('change', () => {
        sessionStorage.setItem('caddy-checked', checkbox.checked ? 'true' : 'false');
      });
    }

  async _addCaddyAndOpenDrawer() {
  if (!this.cart) {
    window.location = window.routes.cart_url;
    sessionStorage.removeItem('caddy-checked');
    return;
  }

  const addResponse = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: 54590143955316,
      quantity: 1,
      sections: this.cart.getSectionsToRender().map(s => s.id),
      sections_url: window.location.pathname
    })
  });

  const parsedState = await addResponse.json();

  if (parsedState.status) {
    this.cart.open(this.submitButton);
    sessionStorage.removeItem('caddy-checked');
    return;
  }

  this.cart.renderContents(parsedState);
  sessionStorage.removeItem('caddy-checked');
}



    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.submitButton.setAttribute('aria-disabled', 'true');
      this.handleErrorMessage();

      const variantIdInput = this.form.querySelector('[name="id"]');
      if (!variantIdInput || !variantIdInput.value) {
        this.submitButton.removeAttribute('aria-disabled');
        return;
      }
      const variantId = variantIdInput.value;

      const cartRes = await fetch('/cart.js', { cache: 'no-store' });
      const cartData = await cartRes.json();
      const alreadyInCart = cartData.items.find(item => item.variant_id === parseInt(variantId));

      const caddyVariantId = 54590143955316;
      const checkbox = document.getElementById('upsell-addon-checkbox');
      const caddyWanted = checkbox && checkbox.checked;
      const caddyInCart = cartData.items.find(item => item.variant_id === caddyVariantId);

         if (alreadyInCart) {
        if (caddyWanted && !caddyInCart) {
          await this._addCaddyAndOpenDrawer();
          this.submitButton.removeAttribute('aria-disabled');
          return;
        }

        // Nothing new to add — show notice but still open drawer
        const existingNotice = this.form.querySelector('#variant-duplicate-notice');
        if (existingNotice) existingNotice.remove();
        const notice = document.createElement('p');
        notice.textContent = 'This option is already in your cart.';
        notice.style.cssText = 'color:#2952E3;font-weight:600;margin-top:8px;';
        notice.id = 'variant-duplicate-notice';
        this.form.appendChild(notice);
        setTimeout(() => notice.remove(), 3000);

        if (this.cart) {
          this.cart.open && this.cart.open(this.submitButton);
        }

        this.submitButton.removeAttribute('aria-disabled');
        return;
      }


      // FlexFlow not in cart — normal add flow
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      this.formIdInputValue = this.form.querySelector('[name=id]').value;
      if (this.formIdInputValue.includes(',')) {
        formData.delete('id');
        formData.delete('quantity');
      }

      config.body = formData;

      this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', 'true');
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.skipCart) {
            window.location = "/checkout";
            return;
          }

          // Add Caddy alongside FlexFlow if checkbox is ticked
          if (caddyWanted && !caddyInCart) {
            await this._addCaddyAndOpenDrawer();
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
